import type { MessageLeadFeedback } from 'src/types/Message';

export type LeadFeedback = MessageLeadFeedback;

const LEAD_FEEDBACK_STORAGE_KEY = 'tghunter-lead-feedback';

export function readFeedbackMap(): Record<string, LeadFeedback> {
    try {
        const raw = window.localStorage.getItem(LEAD_FEEDBACK_STORAGE_KEY);
        return raw ? (JSON.parse(raw) as Record<string, LeadFeedback>) : {};
    } catch (_error) {
        return {};
    }
}

export function writeFeedback(messageId: number, feedback: LeadFeedback) {
    try {
        const current = readFeedbackMap();
        const next = { ...current };
        if (feedback) {
            next[String(messageId)] = feedback;
        } else {
            delete next[String(messageId)];
        }
        window.localStorage.setItem(LEAD_FEEDBACK_STORAGE_KEY, JSON.stringify(next));
    } catch (_error) {
        return;
    }
}

export function getSavedFeedback(messageId: number): LeadFeedback {
    return readFeedbackMap()[String(messageId)] || null;
}

export function getFeedbackLabel(feedback: LeadFeedback) {
    if (feedback === 'good') return 'Хороший лид';
    if (feedback === 'bad') return 'Не подходит';
    return null;
}
